import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { formatErr } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@jawaitrails.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") { toast.error("Not an admin"); return; }
      nav("/admin");
    } catch (err) { toast.error(formatErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] grid place-items-center jt-container">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl p-8 ring-1 ring-black/5" data-testid="admin-login-form">
        <div className="jt-eyebrow mb-2">Admin portal</div>
        <h1 className="font-serif text-3xl text-[#1E3A2B] mb-6">Sign in</h1>
        <label className="jt-eyebrow mb-2 block">Email</label>
        <Input value={email} onChange={(e) => setEmail(e.target.value)} className="mb-4" data-testid="admin-email"/>
        <label className="jt-eyebrow mb-2 block">Password</label>
        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mb-5" data-testid="admin-password"/>
        <button className="jt-pill-primary w-full justify-center" disabled={busy} data-testid="admin-signin">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
